'use strict';

import { ACTIVE_MODULE, UserStoreService } from '../services/userStore/UserStoreService';
import { configPromise } from 'config';
import AppError from '../utils/appError';
import ErrorActions from './registerErrorAction';

var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');
var ModuleApi = require('../api/moduleApi');

/**
 * Module actions
 * @type {{getModuleList: ModuleAction.getModuleList}}
 */
var ModuleAction = {

  /**
   * Get module list
   */
  async getModuleList() {
    const lastActiveModule = await UserStoreService.getInstance().get(ACTIVE_MODULE);
    const defaultModuleCode = (await configPromise).defaultModule;
    const response = await ModuleApi.getModuleList();

    if (AppError.isError(response)) {
      ErrorActions.registerError(response);
    } else {
      Dispatcher.dispatch({
        actionType: ActionType.MODULE_GET_LIST,
        moduleList: response,
        lastActiveModule,
        defaultModuleCode
      });
    }
  },

  async setCurrentModule(moduleCode) {
    UserStoreService.getInstance().patch(ACTIVE_MODULE, moduleCode);
    Dispatcher.dispatch({ actionType: ActionType.MODULE_SET_CURRENT_MODULE, moduleCode });
  }

};

module.exports = ModuleAction;
